var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("奥迪 A3 ")]),_c('el-row',[_c('el-col')],1),_c('div',{attrs:{"id":"chart_example"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }